import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsBoolean } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class BankAccount {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  bankName!: string;
  @IsString()
  @Expose()
  accountNumber!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
}

export class BankAccountResponse extends GenericTableResponse<BankAccount> {
  @Expose()
  @IsArray()
  @Type(() => BankAccount)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BankAccount>;
}
